// axios
import axios from "axios";
import store from "./store/store";
import * as Sentry from "@sentry/browser";
const domain = process.env.VUE_APP_API_BASE_URL;

export default () => {
  if (
    store.state.oidcStore.access_token == null ||
    store.state.oidcStore.access_token == ""
  ) {
    Sentry.captureMessage(
      "Access token is null or empty",
      Sentry.Severity.Warning
    );
  }
  let axiosInstance = axios.create({
    baseURL: domain,
    headers: {
      Authorization: `Bearer ${store.state.oidcStore.access_token}`,
      "Content-Type": "application/json"
    },
    withCredentials: process.env.VUE_APP_SEND_CREDENTIALS
    // You can add your headers here
  });
  axiosInstance.interceptors.request.use(
    config => {
      store.commit("updateLoading", 1);
      return config;
    },
    error => {
      store.commit("updateLoading", -1);
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    response => {
      store.commit("updateLoading", -1);
      return response;
    },
    error => {
      store.commit("updateLoading", -1);
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};
